import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import Error from '../Error';
import { InfoLink } from 'components/Tables/CustomTable';
import { useRetailer } from 'utils/hooks';

export default function Container({
  title = '',
  id = '',
  docUrl = '',
  description = '',
  cssStyles = {},
  legend = null,
  children = null,
  compact = false,
  isError = false,
  onReload = () => {},
  className = '',
  headerClassName = '',
  titleClassName = '',
  contentClassName = ''
}) {
  const { isSSRStore } = useRetailer();

  return (
    <div className={cn(styles.container, className)} style={cssStyles}>
      <div className={cn(styles.header, headerClassName)}>
        <div className={styles.headerContent}>
          <div className={cn(styles.title, titleClassName)}>
            <h4>{title}</h4>
            <If test={!isSSRStore}>
              <InfoLink id={id} url={docUrl} />
            </If>
          </div>
          {description && <p className={styles.description}>{description}</p>}
        </div>
        {legend && <div className={styles.legend}>{legend}</div>}
      </div>
      <div
        data-compact={!!compact}
        className={cn(styles.content, contentClassName)}
      >
        <Error isError={isError} onReload={onReload}>
          {children}
        </Error>
      </div>
    </div>
  );
}
